/* Reveal au defilement, source unique.

   Il en existait deux implementations : un <script> inline dans mm-best-seller (seuil 0,15 et
   marge -10%) et assets/section-mm-brand-presentation.js (seuil 0,2). Meme comportement, deux
   endroits, donc deux fois a corriger -- la reutilisation ne passait pas par un fichier commun.
   Les seuils, eux, sont propres a chaque section : ils restent des DONNEES portees par le
   markup, pas des variantes de code.

   Usage : data-mm-reveal sur la racine, optionnellement
           data-mm-reveal-threshold="0.15" et data-mm-reveal-margin="0px 0px -10% 0px". */
(() => {
  const setup = (root) => {
    if (root.dataset.mmRevealPret === '1') return;
    root.dataset.mmRevealPret = '1';

    const reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduit || typeof IntersectionObserver === 'undefined') {
      root.classList.add('is-revealed');
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: Number(root.dataset.mmRevealThreshold ?? 0.2),
        rootMargin: root.dataset.mmRevealMargin ?? '0px',
      }
    );
    observer.observe(root);
  };

  const boot = (scope) => (scope || document).querySelectorAll('[data-mm-reveal]').forEach(setup);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }
  /* Charge en `defer`, ce fichier ne rejoue pas quand l'editeur de theme reinjecte une section. */
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
